import EyeIcon from '@mui/icons-material/Visibility';
import Button from '@mui/material/Button';
import LinearProgress from '@mui/material/LinearProgress';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { format } from 'date-fns/format';
import { formatPaymentType, PaymentType } from '../../../../common/enums';
import { CustomerInfo } from '../../../../common/types';

interface TableProps {
  isLoading: boolean;
  paginatedCustomers: CustomerInfo[];
  onCustomerSuspended: (customer: CustomerInfo) => void;
  onShowLoyaltyPointsHistory: (customer: CustomerInfo) => void;
}

export default function CustomerManagementTable({
  isLoading,
  paginatedCustomers,
  onCustomerSuspended,
  onShowLoyaltyPointsHistory
}: TableProps) {
  return (
    <Table sx={{ maxWidth: '100%', overflowX: 'auto' }} size="small">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Email</TableCell>
          <TableCell>Contact Number</TableCell>
          <TableCell>Sign-Up Date</TableCell>
          <TableCell>Number of Orders</TableCell>
          <TableCell>{formatPaymentType(PaymentType.LoyaltyPoints)}</TableCell>
          <TableCell>Suspended?</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading && (
          <TableRow>
            <TableCell colSpan={7} sx={{ padding: 0, margin: 0 }}>
              <LinearProgress variant='indeterminate' color='primary' />
            </TableCell>
          </TableRow>
        )}

        {paginatedCustomers.map((customer) => {
          const createdDate = customer.createdAt
            ? format(customer.createdAt, 'dd/MM/yy')
            : '';
          let loyaltyPointsAvailable = customer.loyaltyPointsBalance ?? 0 - customer.loyaltyPointReserved ?? 0;
          if (loyaltyPointsAvailable < 0) {
            loyaltyPointsAvailable = 0;
          }
          const hasPendingLoyaltyPoints = customer.loyaltyPointReserved > 0;

          return (
            <TableRow
              key={customer.email}
              sx={{
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <TableCell>
                {customer.firstName} {customer.lastName}
              </TableCell>
              <TableCell>{customer.email}</TableCell>
              <TableCell>{customer.phoneNumber}</TableCell>
              <TableCell>{createdDate}</TableCell>
              <TableCell>{customer.orderCount ?? 0}</TableCell>
              <TableCell>
                <Button
                  onClick={() => onShowLoyaltyPointsHistory(customer)}
                  endIcon={<EyeIcon />}
                  color={hasPendingLoyaltyPoints ? 'warning' : 'primary'}
                >
                  {loyaltyPointsAvailable > 0 ? loyaltyPointsAvailable : 0}
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  color={customer.isActive ? 'inherit' : 'error'}
                  onClick={() => onCustomerSuspended(customer)}
                  disabled={isLoading}
                  sx={{textTransform: 'capitalize'}}
                >
                  {customer.isActive ? 'No - Suspend' : 'Yes - Reactivate'}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
